import { useState, useEffect } from "react";

// Data de referência da última atualização divulgada.
// Ajuste esta data sempre que publicar novidades novas.
const DATA_ATUALIZACAO = new Date("2026-08-11T00:00:00");
const DIAS_JANELA_AUTOMATICA = 2;
const STORAGE_KEY = "onbox_novidades_last_shown";

function hojeString() {
  return new Date().toISOString().split("T")[0];
}

function estaDentroDaJanela() {
  const hoje = new Date();
  const diffDias = Math.floor((hoje - DATA_ATUALIZACAO) / (1000 * 60 * 60 * 24));
  return diffDias >= 0 && diffDias <= DIAS_JANELA_AUTOMATICA;
}

export default function useNovidadesAutoShow() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!estaDentroDaJanela()) return;
    try {
      const ultimoDia = localStorage.getItem(STORAGE_KEY);
      if (ultimoDia !== hojeString()) {
        setShow(true);
        localStorage.setItem(STORAGE_KEY, hojeString());
      }
    } catch {
      // localStorage indisponível — não força exibição
    }
  }, []);

  return [show, setShow];
}